import React from 'react'
import ReactDOM from 'react-dom/client'
import PlannerErrorBoundary from './PlannerErrorBoundary'
import ProductionPlanner from './ProductionPlanner'
import './styles.css'
import './equipment.css'
import './production-planner.css'
import './planner-polish.css'
import './production-assets.css'
import './fixed-equipment.css'
import './planner-completion.css'
import './runtime.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PlannerErrorBoundary>
      <ProductionPlanner />
    </PlannerErrorBoundary>
  </React.StrictMode>,
)
